import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { showApiErrorToast } from '@/utils/errors';
import { deleteLeaveType, leaveTypeQueryKeys } from '../api/leaveTypes.api';

export function useDeleteLeaveType() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: number) => deleteLeaveType(id),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: leaveTypeQueryKeys.all() });
      toast.success('Leave type deleted successfully');
    },
    onError: (error) => {
      showApiErrorToast(error, 'Failed to delete leave type');
    },
  });
}
